var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404"},[_c('div',{staticClass:"404__inner"},[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("404")])]),_c('div',[_vm._v("Sorry, the page you have searched for is not available.")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }